import router from '../../router'
import { cancelAllRequests } from '../../services/api'
import VueJwtDecode from 'vue-jwt-decode'

export const auth = {
    state: {
        status: 'loggedOut',
        token: null,
        refreshToken: null,
        login: '',
        fetchData: true
    },
    mutations: {
        SET_AUTH_STATUS(state, status) {
            state.status = status
        },
        SET_AUTH_TOKEN(state, token) {
            state.token = token
        },
        SET_LOGIN(state, login) {
            state.login = login
        },
        SET_FETCH_DATA(state, payload) {
            state.fetchData = payload
        },
        SET_REFRESH_TOKEN(state, payload) {
            state.refreshToken = payload
        }
    },
    actions: {
        setAuthToken({ commit }, payload) {
            commit('SET_AUTH_TOKEN', payload)
        },
        setRefreshToken({ commit }, payload) {
            commit('SET_REFRESH_TOKEN', payload)
        },
        async fetchData({ dispatch, getters }) {
            await dispatch('userDataFetch')
            // dispatch('storesFetch')
            dispatch('newsFetch', {
                limit: 5,
                offset: 0
            }).then(() => {
                dispatch('alertsFetch')
            })
            setInterval(() => {
                dispatch('newsFetch', {
                    limit: 5,
                    offset: 0
                }).then(() => {
                    dispatch('alertsFetch')
                })
            }, 1000 * 60 * 5)
            setInterval(() => {
                dispatch('diagnosticsFetch', {
                    mode: 'details'
                })
            }, 1000 * 60 * 10)
            dispatch('promoTypesFetch')
            dispatch('companiesFetchForFilters')

            await dispatch('consentsFetch')

            const shouldDisplayConsentsModal =
                getters.getMarketingConsents &&
                getters.getMarketingConsents.map(e => e.state).indexOf(null) >
                    -1 &&
                !getters.isShopUser

            if (getters.isLotteryUser) {
                if (!getters.getServices || getters.getServices.length === 0) {
                    await dispatch('servicesFetch')
                }
                const lotteryService = getters.getServices.find(
                    service => service.code === 'loterie2_g3'
                )

                const lotteryId = lotteryService && lotteryService.id
                lotteryId && dispatch('serviceFetch', lotteryId)

                const isLotteryActive = !!(
                    lotteryService &&
                    lotteryService.number_of_entities_with_subscription > 0
                )
                if (!isLotteryActive || shouldDisplayConsentsModal) {
                    dispatch('openModal', {
                        component: 'LotteryNewUserModals'
                    })
                }
            } else if (shouldDisplayConsentsModal) {
                dispatch('openModal', {
                    component: 'ConsentsModal',
                    args: {
                        consentCode: 'EP'
                    }
                })
            }
            dispatch('diagnosticsFetch', {
                mode: 'details'
            })
            return dispatch('merchantsFetch')
        },
        checkHash({ dispatch }, payload) {
            return this.$api
                .get(`check_email_hash/?hash=${payload}`)
                .then(res => {
                    if (res.data?.message?.email) {
                        return res.data.message.email
                    } else {
                        return false
                    }
                })
                .catch(err => {
                    return false
                })
        },
        resetPass({ dispatch, commit }, payload) {
            return this.$api
                .post('set_new_password', payload)
                .then(res => {
                    if (res.status === 200) {
                        dispatch('addNotification', {
                            type: 'success',
                            title: 'Logowanie',
                            content: 'Hasło zostało pomyślnie zmienione'
                        })
                        setTimeout(() => {
                            router.push({ name: 'promo-list' })
                        }, 1000)
                    } else {
                        dispatch('addNotification', {
                            type: 'danger',
                            title: 'Logowanie',
                            content: 'Wystąpił błąd'
                        })
                    }
                })
                .catch(() => {
                    dispatch('addNotification', {
                        type: 'danger',
                        title: 'Logowanie',
                        content: 'Wystąpił błąd'
                    })
                })
        },
        authLogin({ state, commit, dispatch }, payload) {
            const { endpoint = 'login', requestBody } = payload
            this.$api
                .post(endpoint, requestBody)
                .then(response => {
                    if (response.status === 200) {
                        commit(
                            'SET_AUTH_TOKEN',
                            response.data.access_token
                        )
                        commit('SET_AUTH_STATUS', 'loggedIn')
                        dispatch('addNotification', {
                            type: 'info',
                            title: 'Logowanie',
                            content: 'Zalogowano'
                        })
                        this.$storage.setItem('login', payload.login)
                        this.$storage.setItem('refreshToken', response.data.refresh_token)
                        this.$storage
                            .setItem(
                                'authToken',
                                response.data.access_token
                            )
                            .then(() => {
                                this.$storage
                                    .getItem('generatedLink')
                                    .then(link => {
                                        if (link) {
                                            dispatch('goToGeneratedLink')
                                        } else {
                                            router.push({ name: 'dashboard' })
                                        }
                                    })

                                commit('SET_AUTH_STATUS', 'loggedIn')
                            })
                    } else {
                        if (
                            Object.prototype.toString.call(response) ===
                            '[object Error]'
                        ) {
                            throw response
                        }
                    }
                })
                .catch(error => {
                    console.error('Brak poprawnej odpowiedzi z serwera')
                    let message = ''

                    if (error.response && error.response.status === 400) {
                        message = 'Błędny login lub hasło'
                    } else if (
                        error.response &&
                        error.response.status === 403 &&
                        error.response.data.message
                    ) {
                        message = error.response.data.message
                    } else {
                        message = 'Wystąpił błąd'
                    }

                    dispatch('addNotification', {
                        type: 'danger',
                        title: 'Logowanie',
                        content: message
                    })

                    commit('SET_AUTH_STATUS', 'loggedOut')
                })
        },
        loginByHash({ dispatch, commit }, hash) {
            commit('SET_AUTH_STATUS', 'pending')

            // Hash is encoded in base64, let's decode it first
            const decodedHash = atob(hash)

            // Extract login and password
            const { login, password } = decodedHash
                .split('&')
                .reduce((acc, pair) => {
                    const [key, value] = pair.split('=')
                    acc[key] = value
                    return acc
                }, {})

            // Załóżmy, że token captcha jest dostępny globalnie jako window.captcha lub przez getter
            const captcha = typeof window !== 'undefined' && window.captcha ? window.captcha : ''
            dispatch('authLogin', {
                requestBody: {
                    login,
                    password,
                    stay_logged: true,
                    captcha
                }
            })
        },
        authRemove({ commit, dispatch }) {
            return new Promise((resolve, reject) => {
                // Abort all pending API requests
                cancelAllRequests()

                // Remove session data from storage except 'appData' and 'initialState'
                this.$storage.iterate((value, key) => {
                    if (!['appData', 'initialState'].includes(key)) {
                        this.$storage.removeItem(key)
                    }
                })

                // Unregister all Vuex modules
                const registeredModules = Object.keys(this._modulesNamespaceMap)
                registeredModules.forEach((namespace) => {
                    this.unregisterModule(namespace.replace('/', ''))
                })

                commit('SET_LOGIN', '')
                this.$storage
                    .removeItem('authToken')
                    .then(() => {
                        // remove from store
                        commit('SET_AUTH_STATUS', 'loggedOut')
                        return this.$storage.getItem('initialState')
                    })
                    .then(initialState => {
                        // replace state with initial state after e.g logout
                        this.replaceState(initialState)

                        dispatch('setDefaultPerPage')

                        resolve()
                    })
                    .catch(error => {
                        console.log(error)
                        reject(error)
                    })
            })
        },
        loadLogin({ commit }) {
            return this.$storage.getItem('login').then(login => {
                commit('SET_LOGIN', login)
            })
        },
        async authLoadToken({ commit, getters }) {
            if (!getters.authToken) {
                const token = await this.$storage.getItem('authToken')
                commit('SET_AUTH_TOKEN', token)
            }
        },
        authCheckTokenValidity({ state, commit, dispatch, getters }) {
            return new Promise((resolve, reject) => {
                dispatch('authLoadToken').then(() => {
                    if (getters.authToken === null || getters.authToken === undefined) {
                        if (router.history.current.name !== 'login') {
                            reject(
                                new Error(
                                    'Błąd odczytu z pamięci podręcznej przeglądarki'
                                )
                            )
                            router.push({ name: 'login' })
                        }
                        return
                    }

                    // check if there is auth data in storage
                    // dispatch('fetchAppData')
                    dispatch('loadLogin')
                    dispatch('loadSelectedPromotions')

                    if (state.fetchData) {
                        commit('SET_AUTH_STATUS', 'pending')
                        dispatch('fetchData')
                            .then(() => {
                                commit('SET_FETCH_DATA', false)
                                resolve()
                                commit('SET_AUTH_STATUS', 'loggedIn')
                            })
                            .catch(err => {
                                commit('SET_AUTH_STATUS', 'loggedOut')
                            })
                    } else {
                        resolve()
                    }
                })
            })
        }
    },
    getters: {
        authStatus: state => {
            return state.status
        },
        authToken: state => {
            if (state.token) {
                return state.token
            }
        },
        getLogin: state => {
            if (state.login) {
                return state.login
            }
        },
        authUser: state => {
            if (state.token) {
                return VueJwtDecode.decode(state.token)
            }
        },
        userId: state => {
            if (state.token) {
                const decoded = VueJwtDecode.decode(state.token)
                return decoded.id
            }
        },
        isLogged: state => {
            return state.status === 'loggedIn'
        }
    }
}
